const isThisASuperAdmin = (email) => {
  const listOfSuperAdmins = ['jjoffe1@gmail.com', '@socialive.us', '@clubcastlive.com'];
  let doesOccur = false;
  const userName = email.toLowerCase();

  for (let i = 0; i < listOfSuperAdmins.length; i += 1) {
    if (userName.indexOf(listOfSuperAdmins[i]) !== -1) {
      doesOccur = true;
    }
  }
  return doesOccur;
};

export default isThisASuperAdmin;
